import { useEffect, useState } from 'react';
import { Select, MenuItem, Typography } from '@mui/material';
import { getClassSectionList } from 'apis/main';
import useClassSection from 'store/section/useClassSection';
import { IPatientInfoSmall } from 'apis/admin/type';

interface IClassSection {
  class_section_id: number;
  college_id?: number;
  class_section_year: number;
  class_section_semester: number;
  class_section_subject: string;
  class_section_grade: number;
  class_section_name: string;
  class_section_teacher_info?: string;
  class_section_create_id?: number;
  class_section_create_date?: string;
}

interface IOption extends IClassSection {
  displayName: string;
}

interface OwnProps {
  user_id: number;
  patientInfo: IPatientInfoSmall;
}
const ClassSectionSelect = (props: OwnProps) => {
  const { user_id } = props;
  const [options, setOptions] = useState<IOption[]>([]);
  const [selectedSection, setSelectedSection] = useState<IOption | null>(null);
  const { onSelectedClassSection, class_section_id, displayName } =
    useClassSection();

  // 전체 학생 선택 옵션
  const allStudentsOption: IOption = {
    class_section_id: -1,
    displayName: 'All Students',
    class_section_year: 0,
    class_section_semester: 0,
    class_section_subject: '',
    class_section_grade: 0,
    class_section_name: '',
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await getClassSectionList({
          user_id,
          size: 100,
          page: 1,
        });
        const processedOptions = [
          allStudentsOption,
          ...(response.data.class_section_list || []).map(
            (option: IClassSection) => ({
              ...option,
              displayName: `${option.class_section_year}년 ${option.class_section_semester}학기 ${option.class_section_subject} ${option.class_section_grade}-${option.class_section_name}`,
            })
          ),
        ];
        setOptions(processedOptions);
      } catch (error) {
        console.error('분반 조회 실패:', error);
      }
    };

    fetchOptions();
  }, []);

  const handleChange = (event: any) => {
    const selected =
      options.find(option => option.class_section_id === event.target.value) ||
      null;
    setSelectedSection(selected);
    onSelectedClassSection(selected as IOption);
  };

  useEffect(() => {
    if (options.length > 0) {
      const selected =
        options.find(option => option.class_section_id === class_section_id) ||
        allStudentsOption;
      setSelectedSection(selected);
    }
  }, [class_section_id, options]);

  return (
    <Select
      value={selectedSection?.class_section_id || ''}
      onChange={handleChange}
      displayEmpty
      fullWidth
      variant="outlined"
      size="small"
      sx={{ width: 300, height: 36, fontSize: '0.875rem' }}
      renderValue={value => {
        if (!value) return displayName;
        return (
          options.find(option => option.class_section_id === value)
            ?.displayName || 'Хичээлийн бүлгийг сонгох'
        );
      }}
    >
      {options.map(option => (
        <MenuItem
          key={option.class_section_id}
          value={option.class_section_id}
          sx={{ padding: '8px 12px', fontSize: '0.875rem', gap: '10p' }}
        >
          {option.class_section_id === -1 ? (
            <Typography variant="subtitle2">{option.displayName}</Typography>
          ) : (
            <Typography variant="subtitle2">
              {`${option.class_section_year}년 ${option.class_section_semester}학기 ${option.class_section_subject} ${option.class_section_grade}-${option.class_section_name}`}
            </Typography>
          )}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ClassSectionSelect;
